import { Identifier } from 'react-admin';

export const scopeLabel = (record: { location_id?: number | null }) =>
  record.location_id ? 'Location override' : 'Company default';

export const locationPositionFilter = (locationId?: Identifier | null) =>
  locationId ? { search: { location_ids: [locationId] } } : undefined;
